import { BACKGROUND_IMAGE_DESKTOP, BACKGROUND_IMAGE_MOBILE } from '../elements/assets'

export const COMPARISON_TABLE = `
...on comparisonTable_Entry {
  id
  typeHandle

  ${ BACKGROUND_IMAGE_DESKTOP }
  ${ BACKGROUND_IMAGE_MOBILE }

  headingAdvanced {
    html
  }

  featureColumnHeader
  leftColumnHeader
  rightColumnHeader

  comparativeOpportunities {
    col1
    col2
    col3
  }

  extend
  heading {
    html
  }
  description

  tipIcon1 {url}
  tipHeading1
  tipDescription1
  tipIcon2 {url}
  tipHeading2
  tipDescription2
  tipIcon3 {url}
  tipHeading3
  tipDescription3
}
`